import axios from 'axios'
import { ListResponse, ResponseArray, Response } from '../../../../../setup/axios/HttpResponse';
import { ProvinceResponse, HousingResponse, GetDispatchRequest, DispatchResponse, CreateDispatchRequest, UpdateDispatchStatusRequest, UpdateDispatchRequest, WorkerResponse, ServiceResponse, GetZoneRequest, ServiceModel, CategoryServiceTreeModel, DispatchRequestSubmitModel, ProvinceListRequest, CentroTransportationConfig } from '../models';
import { API_URL } from '../../../../utils/common/constants'
import { ZoneListResponse } from '../../zones/models';
import { OperationHoursAndMap } from 'app/modules/users/models/OperationHoursAndMap';

const dispatchApi = {
  getDispatch(body: GetDispatchRequest): Promise<ListResponse<{ rows: DispatchResponse[] }>> {
    const url = `${API_URL}/api/v1/dispatch/search`
    return axios.post(url, body)
  },

  getProvince(body: ProvinceListRequest): Promise<any> {
    const url = `${API_URL}/api/v1/provine/search`;
    return axios.post(url, body);
  },

  getHousing(provinceId: number): Promise<ResponseArray<HousingResponse>> {
    const url = `${API_URL}/api/v1/housing/province/${provinceId}`
    return axios.get(url)
  },

  getWorkers(housingId: number): Promise<ResponseArray<WorkerResponse>> {
    const url = `${API_URL}/api/v1/dispatch/worker-cluster?HousingId=${housingId}`
    return axios.get(url)
  },

  getServices(dispatchId?: number | null): Promise<ResponseArray<CategoryServiceTreeModel>> {
    const url = `${API_URL}/api/v2/dispatch/service-cluster${dispatchId ? `?dispatchId=${dispatchId}` : ''}`
    return axios.get(url)
  },

  createDispatch(body: CreateDispatchRequest): Promise<Response<any>> {
    const url = `${API_URL}/api/v1/dispatch`
    return axios.post(url, body)
  },

  updateStatusDispatch(body: UpdateDispatchStatusRequest): Promise<Response<any>> {
    const url = `${API_URL}/api/v1/dispatch/change-status`
    return axios.post(url, body)
  },

  getDispatchById(dispatchId: number): Promise<Response<DispatchResponse>> {
    const url = `${API_URL}/api/v1/dispatch/item?Id=${dispatchId}`
    return axios.get(url)
  },

  addAndEditDispatch(body: DispatchRequestSubmitModel): Promise<Response<any>> {
    const url = `${API_URL}/api/v1/dispatch/save`
    return axios.post(url, body)
  },

  getZone(body: GetZoneRequest): Promise<ListResponse<ZoneListResponse>> {
    const url = `${API_URL}/api/v1/zones/paging`
    return axios.post(url, body)
  },
  getOperationHoursAndMaps(): Promise<ResponseArray<OperationHoursAndMap>> {
    const url = `${API_URL}/api/v1/company-user/get-operation-hours-map`;
    return axios.get(url)
  },
  getClusterWorkingHours(): Promise<ResponseArray<any>> {
    const url = `${API_URL}/api/v1/dispatch/get-all-cluster-working-hour`;
    return axios.get(url)
  },
  getClusterBuses(housingId: number): Promise<ResponseArray<any>> {
    const url = `${API_URL}/api/v1/dispatch/transport-vehicle?HousingId=${housingId}`;
    return axios.get(url)
  },
  checkBusHasActiveCluster(busId: string): Promise<ResponseArray<any>> {
    const url = `${API_URL}/api/v1/dispatch/check-bus-has-active-cluster?busId=${busId}`;
    return axios.get(url);
  },
  getCategoryTransportationConfig(categoryId: string | number): Promise<Response<CentroTransportationConfig | null>> {
    const url = `${API_URL}/api/v1/centro-transportation-config/${categoryId}`;
    return axios.get(url);
  },
}

export default dispatchApi
